<template>
    <div>
        <!--导航栏 start-->
        <van-search
          v-model="order_no"
          show-action
          placeholder="请输入订单编号"
          @search="onSearch"
          @cancel="onCancel"
        />
        <!--导航栏 end-->
        <!-- 列表 start-->
        <van-grid :column-num="5" :border="false">
            <van-grid-item  text="订单编号" />
            <van-grid-item  text="支付金额" />
            <van-grid-item  text="取餐号" />
            <van-grid-item  text="订单状态" />
            <van-grid-item  text="操作" />
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
        >
            <van-cell v-for="item in list" :key="item.id">
                <van-grid :column-num="5" :border="false">
                    <van-grid-item :text="item.order_no" />
                    <van-grid-item :text="'￥'+item.money" />
                    <van-grid-item :text="item.order_status==0||item.order_status==-1?'无':item.take_food_no">
					</van-grid-item>
					<van-grid-item v-if="item.order_status==-1" :text="item.order_status=='-1'?'已取消':''" />
                    <van-grid-item v-else :text="['支付中','已支付','撤销支付','退款'][item.order_status]" />
                    <van-grid-item>
                        <div @click.stop="order_detail(item.id)" style="color: red;">详情</div>
                    </van-grid-item>

<!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
<!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem,Search} from 'vant';
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "Order",
        data(){
            return{
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
				//点餐订单编号
				order_no:'',
            }
			
        },
        methods:{
			onSearch(v){
			  this.order_no=v;
			  this.page=1;
			  this.list=[];
			  this.getList();
			},
			onCancel(){
			  this.order_no='';
			  this.page=1;
			  this.list=[];
			  this.getList();        
			},
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/StoreHomepage');
            },
            getList() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.post('/wechat/api.order/consumer_order', {
					pageNum: this.page,
					pageSize: this.limit,
					order_no:this.order_no,
					}).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
			order_detail(id) {
			    // this.$router.push("/SalesmanUpdate/"+id);
			    this.$router.push({path:"/OrderDetails", query:{id:id}})
			    // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
			},
        },

    }
</script>

<style scoped>
.search option{
	padding: 0.5rem;
	color: red;
	font-size: 0.5rem;
}
</style>
